import React from "react";
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { TextField } from "@material-ui/core";

import "../styles.css"

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

function TextMaskCustomCel(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

const status = [
    { value: 'ativo', label: 'ativo' },
    { value: 'inativo', label: 'inativo' },
];

const admin = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
];

const exercicio = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
];

const funcoes = [
    { value: 'Equipe Local', label: 'Equipe Local' },
    { value: 'Supervisor da Usina', label: 'Supervisor da Usina' },
    { value: 'Equipe de Comunicação', label: 'Equipe de Comunicação' },
    { value: 'Coordenador Técnico Civil', label: 'Coordenador Técnico Civil' },
    { value: 'Coordenador Executivo do PAE', label: 'Coordenador Executivo do PAE' },
    { value: 'Equipe de Segurança de Barragens', label: 'Equipe de Segurança de Barragens' },
    { value: 'Coordenador Técnico Eletromecânico', label: 'Coordenador Técnico Eletromecânico' },
    { value: 'Equipe de Plantão de Operação Hidráulica', label: 'Equipe de Plantão de Operação Hidráulica' },
    { value: 'Equipe do Centro de Operação do Sistema (COS)', label: 'Equipe do Centro de Operação do Sistema (COS)' },
];

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
    };

    return (
        <>
            <div className="fundo">
                <div className="rowForm">
                    <div className="nome">
                        <TextField
                            margin="dense"
                            id="nome"
                            label="Nome Completo"
                            value={props.values.nome}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="autoDois">
                        <TextField
                            id="email"
                            type="email"
                            margin="dense"
                            label="E-mail"
                            disabled={props.update === true ? true : false}
                            value={props.values.email}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="autoDois">
                        <TextField
                            margin="dense"
                            id="cargo"
                            label="Cargo"
                            value={props.values.cargo}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="autoTres">
                        <TextField
                            margin="dense"
                            id="telefone"
                            label="Telefone"
                            onChange={handleChange}
                            value={props.values.telefone}
                            InputProps={{ inputComponent: TextMaskCustom }}
                        />
                    </div>

                    <div className="autoTres">
                        <TextField
                            margin="dense"
                            id="celular"
                            label="Celular"
                            onChange={handleChange}
                            value={props.values.celular}
                            InputProps={{ inputComponent: TextMaskCustomCel }}
                        />
                    </div>

                    <div className="autoTres">
                        <TextField
                            select
                            id="admin"
                            size="small"
                            label="Acesso Interface Administrativa"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.admin}
                            SelectProps={{ native: true }}
                        >
                            {admin.map((option) => (
                                <option key={option.value} >
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>
                </div>

                <div className="rowForm">
                    <div className="autoTres">
                        <TextField
                            select
                            id="status"
                            size="small"
                            label="Status"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.status}
                            SelectProps={{ native: true }}
                        >
                            {status.map((option) => (
                                <option key={option.value} >
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>

                    <div className="autoTres">
                        <TextField
                            select
                            id="funcao"
                            size="small"
                            label="Função"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.funcao}
                            SelectProps={{ native: true }}
                        >
                            {funcoes.map((option) => (
                                <option key={option.value} >
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>

                    <div className="autoTres">
                        <TextField
                            select
                            id="em_exercicio"
                            size="small"
                            label="Funcionário em Exercício?"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.em_exercicio}
                            SelectProps={{ native: true }}
                        >
                            {exercicio.map((option) => (
                                <option key={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>

                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
